let baseUrl = process.env.REACT_APP_INFEST_BASE_URL


async function getPlaceName(lat, lon) {
    const url = `${baseUrl}/api/centroids?latitude=${lat}&longitude=${lon}`;

    const response = await fetch(url);
    return await response.json(); // This contains detailed address information
  }

  export default getPlaceName;

//   async function getNamesFromLocation(lat, long) {

//     let locationNames = await axios({
//       method: 'GET',
//       url: https://infestserver.apps.niruthi.com/api/centroids?latitude=${lat}&longitude=${long},
//       headers: {
//         Authorization: Bearer ${token},
//       },
//     });
//     const {state, district, sub_dist, village} = locationNames.data.location;
//     if (locationNames.data.location) {
//       setSelectedState(state);
//       setSelectedDistrict(district);
//       setSelectedSub_dist(sub_dist);
//       setSelectedVillage(village);
//     }
//   }